/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_MetadataInputs */

const en_transcript_export_include_metadata = /** @type {(inputs: Transcript_Export_Include_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Metadata`)
};

const fr_transcript_export_include_metadata = /** @type {(inputs: Transcript_Export_Include_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclure les metadonnees`)
};

const de_transcript_export_include_metadata = /** @type {(inputs: Transcript_Export_Include_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten einbeziehen`)
};

const it_transcript_export_include_metadata = /** @type {(inputs: Transcript_Export_Include_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includi metadati`)
};

const ru_transcript_export_include_metadata = /** @type {(inputs: Transcript_Export_Include_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить метаданные`)
};

const es_transcript_export_include_metadata = /** @type {(inputs: Transcript_Export_Include_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir metadatos`)
};

const zh_cn2_transcript_export_include_metadata = /** @type {(inputs: Transcript_Export_Include_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含元数据`)
};

const ja_transcript_export_include_metadata = /** @type {(inputs: Transcript_Export_Include_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータを含める`)
};

const hi_transcript_export_include_metadata = /** @type {(inputs: Transcript_Export_Include_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा शामिल करें`)
};

const pt_pt2_transcript_export_include_metadata = /** @type {(inputs: Transcript_Export_Include_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir metadados`)
};

/**
* | output |
* | --- |
* | "Include Metadata" |
*
* @param {Transcript_Export_Include_MetadataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_metadata = /** @type {((inputs?: Transcript_Export_Include_MetadataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_MetadataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_include_metadata(inputs)
	if (locale === "de") return de_transcript_export_include_metadata(inputs)
	if (locale === "it") return it_transcript_export_include_metadata(inputs)
	if (locale === "ru") return ru_transcript_export_include_metadata(inputs)
	if (locale === "es") return es_transcript_export_include_metadata(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_include_metadata(inputs)
	if (locale === "ja") return ja_transcript_export_include_metadata(inputs)
	if (locale === "hi") return hi_transcript_export_include_metadata(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_include_metadata(inputs)
	return en_transcript_export_include_metadata(inputs)
});